export class HistoryDiff {
    old_history_id: -1;
    old_history_date: "";
    new_history_id: -1;
    new_history_date: "";
    changes: Array<object>;
}